


























































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { orderIds, ancelOrder } from "@/api/api.config";
import { Dialog } from "vant";
@Component
export default class my_bookings extends Vue {
  topList: any = [
    {
      id: "",
      name: "全部",
    },
    {
      id: 0,
      name: "待检测",
    },
    {
      id: 2,
      name: "检测中",
    },
    {
      id: 6,
      name: "检测成功",
    },
    {
      id: 8,
      name: "检测失败",
    },
    {
      id: 5,
      name: "已取消",
    },
  ];
  timer: any = null;
  screen: any = "";
  productId: any = 1;
  option1: any = [
    { text: "新能源汽车动力电池检测", value: 1 },
    { text: "车辆历史报告", value: 2 },
    { text: "新能源汽车动力电池线上检测", value: 5 },
  ];
  isShow = true;
  show = false;
  showOver: any = false;
  value = "";
  loading = false;
  finished = false; //是否加载完成 加载完不在触发load事件
  refreshing = false; // 下拉状态
  // orderName = "订单已确认";
  userId: any = "";
  pageNum: any = 1;
  pageCount: any = 10;
  status: any = "";
  list: any = [];
  clientIndex: any = 0;
  totalElements: any = 0;
  shopData: any = "";
  // showPopup() {
  //   if (this.orderName == "订单已确认") {
  //     this.show = true;
  //   } else {
  //     this.show = false;
  //   }
  // }
  // { pageNumber: this.pageNum, pageSize: this.pageCount }
  // addCancel() {
  //   this.isShow = false;
  //   this.show = false;
  //   this.orderName = "订单待确认";
  // }

  tosearchBg(item: any) {
    if (this.productId == 5) {
      // this.$router.push({
      //   path: "/online",
      //   query: { orderId: item.orderId },
      // });
      if (item.reportUrl == null) return;
      window.location.href = item.reportUrl;
    } else {
      if (item.lemonReportUrl == null) return;
      window.location.href = item.lemonReportUrl;
    }
  }
  todoList(id: any) {
    // this.clientIndex = index;
    this.status = id;
    this.pageNum = 1;
    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
  }

  changeValuesearch(e: any) {
    this.screen = e.target.value;
    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
  }

  orderIdsList(productId: any, status: any, screen: any, pageNum: any) {
    this.finished = true;
    orderIds({
      productId: productId,
      status: status,
      screen: screen,
      page: this.pageNum || pageNum,
      size: this.pageCount,
    })
      .then((res) => {
        console.log(res);
        this.finished = false;
        this.totalElements = res.data.totalElements;
        if (this.pageNum == 1) {
          this.list = res.data.content;
        } else {
          //页数加1再次调用接口赋值数据
          this.list = this.list.concat(res.data.content);
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  // 下拉刷新
  onRefresh() {
    setTimeout(() => {
      this.list = [];
      this.pageNum = 1;
      this.refreshing = false;
      this.finished = false; // 如果数据全部加载完毕之后，下拉刷新需要把finished质为false
      this.$toast("刷新成功");
      if (this.productId == 0) return;
      this.orderIdsList(this.productId, this.status, this.screen, this.pageNum); //调用请求接口数据的方法
    }, 1000);
  }
  mounted() {
    // this.bus.$on("statusIndex", (data: any) => {
    //   console.log(data,2222);

    //   this.status = data;
    //   console.log(this.status,1111);

    // });
    // console.log(this.status, 22222);

    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
    this.shopData = localStorage.getItem("shopData");
  }
  activated() {
    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
  }
  // 上拉加载
  onLoad() {
    if (this.finished) return;
    this.loading = false;
    if (this.pageNum * this.pageCount >= this.totalElements)
      return this.$toast("数据加载完毕");
    this.pageNum++;
    if (this.productId == 0) return;
    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum); //调用请求接口数据的方法
  }

  toDetail(orderId: any) {
    console.log(this.status);
    this.$router.push({
      path: `/My/my-detail/${this.status}`,
      query: { orderId: orderId },
    });
  }

  startTest(orderId: any) {
    this.$router.push({
      path: "/home",
      query: { orderId: orderId },
    });
  }

  createAgain(orderId: any) {
    this.$router.push({
      path: "/home",
      query: { orderId: orderId },
    });
  }

  report(item: any) {
    if (item.productType === 0) {
      if (item.deviceFactoryId === "zqy") {
        this.$router.push({
          path: `/bari`,
          query: {
            orderId: item.orderId,
          },
        });
      } else {
        this.$router.push({
          path: `/sgs`,
          query: {
            orderId: item.orderId,
          },
        });
      }
    } else if (item.productType === 2) {
      // this.$router.push({
      //   path: `/online`,
      //   query: {
      //     orderId: item.orderId,
      //   },
      // });
      if (item.lemonReportUrl == null) return;
      window.location.href = item.lemonReportUrl;
    }
  }
  // 新的预约
  goHomesingle(orderId: any) {
    this.$router.push({
      path: "/home",
    });
  }
  async ancelOrder(orderId: any) {
    let result = await ancelOrder(orderId);
    console.log(result);
  }
  // 取消预约
  cancleOrder(orderId: any) {
    this.showOver = true;
    this.$dialog
      .confirm({
        title: "",
        message: "确定取消该订单吗",
        confirmButtonText: "关闭",
        cancelButtonText: "取消订单",
      })
      .then(async () => {
        console.log("点击了确认按钮噢");
        this.showOver = false;
      })
      .catch(() => {
        this.ancelOrder(orderId);
        this.$nextTick(() => {
          this.orderIdsList(
            this.productId,
            this.status,
            this.screen,
            this.pageNum
          );
        });
        this.showOver = false;
      });
    // Dialog.confirm({
    //   title: "",
    //   overlay:true,
    //   message: "确定取消该订单吗?",
    //   confirmButtonText: "关闭",
    //   cancelButtonText: "取消订单",

    //   beforeClose(action, done) {
    //     if (action === "confirm") {
    //       setTimeout(done, 1000);
    //       that.showOver =false
    //     } else {
    //       done();
    //       that.showOver =false
    //       that.ancelOrder(orderId);
    //       that.$nextTick(()=>{
    //         that.orderIdsList(that.productId, that.status, that.screen, that.pageNum);
    //       })
    //     }
    //   },
    // });
    console.log(orderId);
  }
  // 筛选
  changeValue(e: any) {
    this.productId = e;
    localStorage.setItem("productId",e)
    if (this.productId == 2) {
      this.orderIdsList(
        this.productId,
        (this.status = ""),
        this.screen,
        this.pageNum
      );
    }
    if (this.productId == 5) {
      this.orderIdsList(
        this.productId,
        (this.status = ""),
        this.screen,
        this.pageNum
      );
    }
    if (this.productId == "0") return;
    // this.shaixuanProduId(this.productId);
    this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
  }
  /* 筛选接口 */
  // shaixuanProduId(producId: any) {
  //   this.finished = true;
  //   orderIds({
  //     producId: producId,
  //     page: this.pageNum,
  //     size: this.pageCount,
  //   })
  //     .then((res) => {
  //       this.finished = false;
  //       this.totalElements = res.data.data.totalElements;
  //       if (this.pageNum == 1) {
  //         this.list = res.data.data.content;
  //       } else {
  //         //页数加1再次调用接口赋值数据
  //         this.list = this.list.concat(res.data.data.content);
  //       }

  //       this.loading = false;
  //     })
  //     .catch(() => {
  //       this.loading = false;
  //     });
  // }

  created() {
    this.userId = this.$route.query.userId;
    this.productId = Number(localStorage.getItem("productId"))
  }

  @Watch("screen")
  change(newVal: any) {
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.screen = newVal;
      this.orderIdsList(this.productId, this.status, this.screen, this.pageNum);
    }, 500);
  }
 
}
